module.exports = __webpack_public_path__ + "media/images/img_side_sumai-1bb10541f07082a343f8ba11039440ef.png";